import $ from 'jquery'

import Side from './Side'
import Step from './Step'

export default class ProductConfigurator {
  side

  montage

  steps

  type

  $options

  $form

  constructor($wrapper) {
    const $variationWrap = $wrapper.find('.single_variation_wrap')

    this.$form = $variationWrap.closest('form')
    this.$options = $wrapper.find('.variations .configurator-options')
    this.montage = null
    this.type = null
    this.steps = this.$options
      .toArray()
      .map(($option, i) => new Step($option, i, this))
    this.side = $variationWrap.length
      ? new Side($variationWrap, this.montage, this.type)
      : null
    this.expandStep()
    this.updateDescription()
    this.$form.on('click', 'button[type="submit"]', (e) => this.clickSubmit(e))
  }

  updateDescription() {
    const $tabDescription = $('#tab-description')
    const $tabDescriptionMoved = $(
      '#tab-description .woocommerce-variation-description',
    )
    const variationDescription = $(
      '.woocommerce-variation .woocommerce-variation-description',
    )

    if ($tabDescription.length && variationDescription.length) {
      if ($tabDescriptionMoved.length) {
        $tabDescriptionMoved.remove()
      }

      variationDescription.appendTo($tabDescription)
    }

    window.requestAnimationFrame(() => this.updateDescription())
  }

  expandStep() {
    if (!this.steps) {
      return
    }

    for (const step of this.steps) {
      if (!step.getSelection()) {
        step.expand()

        return
      }
    }

    this.side?.expand()
  }

  updateSelection(side, name, value) {
    switch (name) {
      case 'attribute_pa_gelaenderform':
        this.type = value
        this.side?.setType(value)
        break
      case 'attribute_pa_montage':
        this.montage = value
        this.side?.setMontage(value)
        break
      default:
    }
  }

  async clickSubmit(e) {
    this.$form.find('#configurator-diagram-input').remove()

    const diagram = this.side?.diagram

    if (diagram && diagram.$container.length) {
      e.preventDefault()

      const $input = $(
        '<input type="hidden" name="configurator_diagram" id="configurator-diagram-input">',
      )

      diagram.resetView()

      const canvas = await diagram.svg2Png()
      const blob = await new Promise((resolve) =>
        canvas.toBlob((b) => resolve(b)),
      )
      const reader = new FileReader()

      reader.readAsDataURL(blob)
      await new Promise((resolve) => {
        reader.onloadend = () => resolve()
      })

      const data = reader.result
      const b64 = data.split(',')[1]

      $input.val(b64)
      this.$form.append($input)
      this.$form.submit()
    }
  }
}
